import React from "react";
import {ArrowRight, Zap} from "lucide-react";
import {Button} from "../ui/button";
import welcomeBanner from "../../assets/welcome-banner.jpg";

const HeroSection = () => {
    return (
        <section id="sobre" className="relative py-20 lg:py-32 overflow-hidden">
            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(${welcomeBanner})`
                }}
            ></div>

            {/* Background overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/90 to-white/85"></div>

            {/* Background decorations */}
            <div
                className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-[#0c1248]/5 to-transparent rounded-full blur-3xl"></div>
            <div
                className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#d03737]/5 to-transparent rounded-full blur-3xl"></div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Mobile CkLayout - Centered */}
                <div className="lg:hidden text-center space-y-12">
                    {/* Logo Section - Smaller and at top */}
                    <div className="flex justify-center">
                        <div className="relative">
                            {/* Main decorative circle - smaller */}
                            <div
                                className="w-32 h-32 bg-gradient-to-r from-[#0c1248]/20 to-[#d03737]/20 rounded-full backdrop-blur-sm border border-white/30 flex items-center justify-center shadow-2xl">
                                <div
                                    className="w-24 h-24 bg-gradient-to-r from-[#0c1248] to-[#d03737] rounded-full flex items-center justify-center shadow-xl">
                                    <img
                                        src={require('../../assets/m4m-logo.png')}
                                        alt="M4M Logo"
                                        className="w-12 h-12"
                                    />
                                </div>
                            </div>

                            {/* Floating decorative elements - smaller */}
                            <div
                                className="absolute -top-2 -right-2 w-8 h-8 bg-[#d03737] rounded-lg opacity-30 animate-pulse"></div>
                            <div
                                className="absolute -bottom-2 -left-2 w-10 h-10 bg-[#0c1248] rounded-lg opacity-30 animate-pulse delay-1000"></div>
                        </div>
                    </div>

                    {/* Content - Centered */}
                    <div className="max-w-4xl mx-auto space-y-8">
                        <div className="space-y-6">
                            <div className="flex justify-center">
                                <div className="inline-flex items-center px-4 py-2 bg-[#0c1248]/10 rounded-full">
                                    <Zap className="w-4 h-4 text-[#d03737] mr-2"/>
                                    <span className="text-sm font-medium text-[#0c1248]">
                                        Tecnologia que resolve
                                    </span>
                                </div>
                            </div>

                            <h1 className="text-4xl font-bold text-gray-900 leading-tight">
                                <span className="block">Manage4Me</span>
                                <span
                                    className="block mt-2 bg-gradient-to-r from-[#0c1248] to-[#d03737] bg-clip-text text-transparent"
                                >
                                    Com a tecnologia que resolve para você.
                                </span>
                            </h1>

                            <p className="text-lg text-gray-600 leading-relaxed">
                                Soluções completas de gestão e organização para impulsionar seu negócio
                                com eficiência, segurança e facilidade de uso.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Button
                                size="lg"
                                className="bg-[#0c1248] hover:bg-[#0c1248]/90 text-white px-8 py-3 group transition-all duration-300 transform hover:scale-105"
                            >
                                Conheça nossos produtos
                                <ArrowRight
                                    className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300"/>
                            </Button>
                            <Button
                                variant="outline"
                                size="lg"
                                className="border-[#d03737] text-[#d03737] hover:bg-[#d03737] hover:text-white px-8 py-3 transition-all duration-300"
                            >
                                Fale conosco
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Desktop CkLayout - Two Columns */}
                <div className="hidden lg:grid lg:grid-cols-2 gap-12 items-center">
                    {/* Content - Left Side */}
                    <div className="space-y-8">
                        <div className="space-y-6">
                            <div className="inline-flex items-center px-4 py-2 bg-[#0c1248]/10 rounded-full">
                                <Zap className="w-4 h-4 text-[#d03737] mr-2"/>
                                <span className="text-sm font-medium text-[#0c1248]">
                  Tecnologia que resolve
                </span>
                            </div>

                            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
                                <span className="block">Manage4Me</span>
                                <span
                                    className="block mt-2 bg-gradient-to-r from-[#0c1248] to-[#d03737] bg-clip-text text-transparent"
                                >
                  Com a tecnologia que resolve para você.
                </span>
                            </h1>

                            <p className="text-lg text-gray-600 leading-relaxed max-w-lg">
                                Soluções completas de gestão e organização para impulsionar seu negócio
                                com eficiência, segurança e facilidade de uso.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <Button
                                size="lg"
                                className="bg-[#0c1248] hover:bg-[#0c1248]/90 text-white px-8 py-3 group transition-all duration-300 transform hover:scale-105"
                            >
                                Conheça nossos produtos
                                <ArrowRight
                                    className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300"/>
                            </Button>
                            <Button
                                variant="outline"
                                size="lg"
                                className="border-[#d03737] text-[#d03737] hover:bg-[#d03737] hover:text-white px-8 py-3 transition-all duration-300"
                            >
                                Fale conosco
                            </Button>
                        </div>
                    </div>

                    {/* Logo Section - Right Side */}
                    <div className="flex justify-center">
                        <div className="relative">
                            {/* Main decorative circle - larger for desktop */}
                            <div
                                className="w-80 h-80 bg-gradient-to-r from-[#0c1248]/20 to-[#d03737]/20 rounded-full backdrop-blur-sm border border-white/30 flex items-center justify-center shadow-2xl">
                                <div
                                    className="w-60 h-60 bg-gradient-to-r from-[#0c1248]/30 to-[#d03737]/30 rounded-full backdrop-blur-sm border border-white/40 flex items-center justify-center">
                                    <div
                                        className="w-40 h-40 bg-gradient-to-r from-[#0c1248] to-[#d03737] rounded-full flex items-center justify-center shadow-xl">
                                        <img
                                            src={require('../../assets/m4m-logo.png')}
                                            alt="M4M Logo"
                                            className="w-20 h-20"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Floating decorative elements */}
                            <div
                                className="absolute -top-4 -right-4 w-16 h-16 bg-[#d03737] rounded-2xl opacity-30 animate-pulse"></div>
                            <div
                                className="absolute -bottom-4 -left-4 w-20 h-20 bg-[#0c1248] rounded-2xl opacity-30 animate-pulse delay-1000"></div>
                            <div
                                className="absolute top-1/3 -right-8 w-12 h-12 bg-gradient-to-r from-[#0c1248] to-[#d03737] rounded-full opacity-40 animate-bounce delay-500"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;